import styled from 'styled-components';

export const StyledCookieMessage = styled.div`
    flex: 0 0 auto;

    .app & {
        display: none;
    }
`;
